module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14GHTNv/tc-custom/9781035874729.jpg?1737196545460",
      "alt": "This image is the cover for the book Tic Tic Goes the Christmas Clock"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tic Tic Goes the Christmas Clock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Join the magical adventures of Nicholas, Alfie, and the other elves in a heartwarming tale of friendship and courage! It’s Alfie’s last year on the sled, and he’s joined by Saer, the new number one Elf in training. But what starts as a final hurrah takes a surprising turn when the sled is struck, leaving Santa badly injured. Desperate to save Christmas, Alfie seeks help from Mother Time, embarking on a thrilling journey filled with unexpected twists, new friends, and the ticking of the Christmas Clock. Can Alfie rise to the challenge and make this his most magical night on the sled? Find out in this enchanting story that will leave you wondering… will Alfie win the race against time?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Oliver F Browne Snr\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Oliver F Browne Snr is one of six children, an identical twin who grew up in a small village in Tipperary, Ireland. He is married to Carmel and a father of two boys. Oliver, aged nine, is the children’s book author of A Cat and Eight Kittens and Gerard, aged eight. As well as writing, he is an avid mountain climber and underage rugby coach at his favourite club, Kilfeacle RFC.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0